import { DataTable } from "@/components/datatable/datatable"
import { DataTableSupabase } from "@/components/datatable/supadatatable"
import { Page, PageTitle } from "@/components/page"
import { usePage } from "@/components/page/hooks"
import { Button } from "@/components/ui/button"
import { supabase } from "@/lib/data"
import { Database, Plus, Trash2 } from "lucide-react"
import { useCallback } from "react"
import { usePermissions } from "@/lib/hooks/usePermissions"

export const kbsources = {
  title: "Collections",
  description: "Manage your knowledge base collections.",
  route: "/docu/kbsources",
  url: "/docu/kbsources",
  icon: Database,
  component,
  group: "docs",
  resource: "collections",
  action: "read",
} satisfies PageConfig

type KBSources = {
  id?: string
  sources?: object[]
  team?: string
  title?: string
  created_at?: string
}

const columns: Columns<KBSources> = {
  title: { header: "Title", size: 600 },
  team: { header: "Team", size: 300, cell: ({ row }) => row.original.team?.["name"] },
  sources: { header: "Sources", size: 120, cell: ({ row }) => row.original.sources && row.original.sources.length > 0 ? row.original.sources.length : 0 },
  created_at: { header: "Created", cell: DataTable.cellRender.date, size: 160 },
}

function component() {
  const { navigate, team } = usePage()
  const { canCreate, canDelete } = usePermissions()

  const menu: DropdownMenuContents = [
    ...(canDelete("collections") ? [{
      title: "Delete", action: async (v) => {
        await supabase.from("kbsources").delete().eq("id", v.id)
      },
      icon: <Trash2 />,
      ask: "Are you sure you want to delete this KB source?",
    }] : []),
  ]

  const filter = useCallback(q => q.eq("team", team?.id), [team])

  return <Page>
    <div className="h-full grid grid-rows-[auto_1fr] gap-4">
      <div className="flex">
        <PageTitle />
        <div className="grow"></div>
        {canCreate("collections") && <div>
          <Button className="rounded-lg" onClick={() => navigate('/docu/kbsources/new')}><Plus className="h-4 w-4" />New Source</Button>
        </div>}
      </div>
      <DataTableSupabase
        table="kbsources"
        columns={columns}
        showSelection
        onRowClick={"/docu/kbsources"}
        sort={["created_at", "desc"]}
        actions={menu.length > 0 ? menu : undefined}
        filter={filter}
        select={`
        *,
        team (
          name
        )
      `}
        enableServerSideFiltering={true}
        searchableColumns={["title"]}
      />
    </div>
  </Page>
}
